let points = {
  firstPlace: 15,
  secondPlace: 9,
  thirdPlace: 5,
  fourthPlace: 3,
  fifthPlace: 2,
  creator: 5
}

export {points}